import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api, refreshSession } from "@/lib/api";

import { tr, reconcileLang } from "@/lib/i18n";
const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const loadMe = useCallback(() => api.get("/auth/me").then(({ data }) => {
    setUser(data);
    reconcileLang(data.lang, (l) => api.put("/auth/lang", { lang: l }));
  }).catch(() => setUser(false)), []);

  useEffect(() => {
    loadMe();
    const out = () => setUser(false);
    window.addEventListener("sr-logout", out);
    return () => window.removeEventListener("sr-logout", out);
  }, [loadMe]);

  useEffect(() => {
    if (!user) return undefined;
    const t = setInterval(() => refreshSession().catch(() => {}), 10 * 60 * 1000);
    return () => clearInterval(t);
  }, [user]);

  const login = async (email, password) => { await api.post("/auth/login", { email, password }); await loadMe(); };
  const register = async (f) => { await api.post("/auth/register", f); await loadMe(); };
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };

  return <AuthCtx.Provider value={{ user, login, register, logout, reload: loadMe }}>{children}</AuthCtx.Provider>;
};

const Checking = () => (
  <div className="min-h-screen grid place-items-center bg-slate-50 text-slate-400 text-sm" data-testid="auth-checking">{tr("Verifica accesso…")}</div>
);

export const ProtectedRoute = ({ children, admin = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Checking />;
  if (!user) return <Navigate to="/accesso" replace state={{ from: loc.pathname }} />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};
